import type { ToneOverlay } from "../index.js";

// Veu "àvia" en català: tendresa, preocupació, menjar i prou abric. Com la "dark", és una
// veu per alleugerir l'ànim, així que les seves línies roten cada dues hores
// (TONE_ROTATE_MS). Cada variant conserva els {marcadors} de la base.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} a prop, rei — atent ara mateix",
    "{hazard} aquí al costat, vida meva. Ull.",
    "{hazard} a prop — no m'agrada gens. Compte.",
    "{hazard} a prop. Ves amb compte, m'escoltes?",
    "{hazard} aquí a prop. No t'allunyis, eh?",
  ],
  "alert.toast.escalation": [
    "El {hazard} va a pitjor, no esperis, fes-me cas",
    "El {hazard} creix, rei — mou-te ja",
    "{hazard} pitjor ara. No siguis tossut, ves.",
    "{hazard} s'escampa. Ai, Senyor. Afanya't.",
  ],
  "alert.toast.inPath": [
    "El {hazard} ve cap a tu — mou-te, vida meva",
    "{hazard} va cap a tu, rei — ves, ves",
    "{hazard} ve a per tu. Amunt, mou-te!",
    "{hazard} gairebé a la porta — surt ja, va",
  ],
  "alert.toast.allClear": [
    "Tot tranquil prop de {place}, gràcies a Déu",
    "{place} està tranquil. Seu, respira.",
    "Segur prop de {place}, rei. Quin ensurt.",
    "Tot bé prop de {place}. Ara beu aigua.",
  ],
  "alert.toast.tap": [
    "Vine, toca aquí — ja et dic jo què fer",
    "Toca, rei — jo t'ho explico",
    "Toca aquí. L'àvia té un pla.",
  ],
  "alert.takeover.title": [
    "{hazard} — au, mou-te, no m'ho discuteixis",
    "{hazard} — amunt! Ves, que és de debò",
    "{hazard} — calla i mou-te, rei",
  ],
  "alert.takeover.details": "Ensenya-m'ho tot",
  "alert.takeover.dismiss": "Sí, sí, d'acord",
  "now.status.allClear": [
    "Tot tranquil, vida meva.",
    "Tranquil ara, rei.",
    "Tot bé — seu, descansa.",
    "Tot bé. Ja has menjat?",
    "Tranquil, gràcies a Déu.",
    "Ben calladet. Descansa una mica.",
    "En pau ara. I abriga't.",
  ],
  "now.status.stayAware": [
    "Atent, eh, rei?",
    "Ull viu, vida meva.",
    "Estigues atent, per mi.",
    "Compte, m'escoltes?",
    "No t'allunyis, va.",
  ],
  "now.status.sub.allClear": [
    "Res a prop ara. Beu aigua.",
    "Tot tranquil. Has menjat alguna cosa?",
    "Res al teu radi. Seu una mica.",
    "Net, rei. Respira.",
    "Res a prop. Posa't una rebeca igual.",
  ],
  "now.activity.empty": [
    "Tot quiet. Has menjat?",
    "No passa res. Descansa una mica.",
    "Tot tranquil. Truca a la mare, eh?",
    "Res per aquí. Pren-te un brou.",
    "Tranquil i en calma. Aprofita, rei.",
  ],
  "onboarding.promise.tagline": "Veïns cuidant veïns, com una família.",
  "onboarding.promise.continue": "Au, entra, entra",
  "onboarding.home.browse": "Només mirant, de moment",
  "you.voice.intro": "Digues-me com t'agrada que et parlin, maca.",
};
